import api from 'api/axios';
import { User } from 'types/api.d';

const commonApi = {
  async getUser() {
    try {
      const response = await api.get('/users/profile/');
      return response.data as User;
    } catch (error) {
      throw error;
    }
  },
  async getCategories() {
    try {
      const response = await api.get('/documents/categories');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getDepartments() {
    try {
      const response = await api.get('/workspace/departments');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export { commonApi };
